import { render, staticRenderFns } from "./ArchivesWaterGateShow.vue?vue&type=template&id=73525c02&"
import script from "./ArchivesWaterGateShow.vue?vue&type=script&lang=js&"
export * from "./ArchivesWaterGateShow.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesWaterGateShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports